import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./GlobalStyles";
import { theme } from "./Theme";

import Navbar from './components/Navbar/Navbar';
import Home from './Home/Home';
import Tutorials from './pages/Tutorials/Tutorials';
import Faqs from './pages/FAQs/Faqs';
import Footer from './components/Footer/Footer';

import './App.css';

function App() {

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="pages/tutorials" element={<Tutorials />} />
        <Route path="pages/faqs" element={<Faqs />} />
      </Routes>
      <Footer />
    </ThemeProvider>
  );
}

export default App;
